export default __webpack_public_path__ + "static/media/iPhonesPC.203b9a0f.png";